export default __webpack_public_path__ + "static/media/main-2.1a9b5bbb.jpg";